<template>
  <div class="my_header">
    <div class="back" @click="goback">
        <i class="icon arrow left"></i>
      </div>
      <div class="title">{{title}}</div>
  </div>
</template>

<script>
export default {
  name: "MyHeader",
  props:{
    title:String
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    goback(){
      this.$router.go(-1)
    }
  }
};
</script>

<style lang="less" scoped>
.my_header{
  height: 40px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
  box-shadow: 0 2px 3px #eee;
  background-color: #fff;
  .back{
    min-width: 40px;
    text-align: center;
  }
  .title{
    font-size: 16px;
    margin-left: 20px;
  }
}
</style>